module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAZCAYAAADNAiUZAAABUElEQVRIiWP8DwQMdAZM9LaQKEtPnbnA4BuSCKapBv7jASdPn/9vYe/3f86C5WAaxKcGwGkpzEKYReh8qluKywJqWcwIthkIbF2CGV69foM1CsRERRgO71kLj+P8knqGiT2NDGYmBpTHKbE+odTHcEtJNQiUuIwsPcmylAXm4+aOiQwpiZFEBRkoiOfMX87w5etXrPLF9dMxxHobMzGDF+bT3fsO/X/67AVODJKHhYianh1O3xTVTYNjdIA1TnFZjGwhCOCzFGYxNoCRZXBZjG4hCNg4B+G1FBcAZ5nbt28zbNq0ieHLly8kpXweHh4GPz8/BlVVVZL0gRMSyEJJyXNAAzYBDSLO4i9feID6/IAYmHCKi0mylAliwBcGJ6d9RFsIAiC1ID2khg7cUlAw7dvnBHY9sQCkFqQHpJdUMCBxCi976QkGZ8th1NJRS4kBAEPjtvWavCjrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jchbtb1-6.png
// module id = 769
// module chunks = 0